import {
  countdownLabel,
  countdownTone,
  daysUntil,
  type CountdownTone,
} from '../../utils/eventDates';

const TONE_CLASSES: Record<CountdownTone, string> = {
  soon: 'bg-red-100 text-red-700',
  month: 'bg-amber-100 text-amber-800',
  later: 'bg-primary-100 text-primary-700',
  past: 'bg-gray-100 text-gray-600',
};

/** "in 23 days" — tinted red this week, amber this month, purple later. */
export function EventCountdown({
  startAt,
  className = '',
}: {
  startAt: Date | string | null | undefined;
  className?: string;
}) {
  if (!startAt) return null;
  const days = daysUntil(startAt);
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${
        TONE_CLASSES[countdownTone(days)]
      } ${className}`}
    >
      {countdownLabel(days)}
    </span>
  );
}
